<template>
    <ks-side-nav id="sidebar" class="vertical">
        <nav-links :routes="routes" style="margin-top: 0.75rem;padding-bottom:0.75rem;"></nav-links>
    </ks-side-nav>
</template>


<script>
    // External Dependencies
    import { mapGetters } from 'vuex';

    // Internal Dependencies
    import AppInfoMixin from '@/mixins/AppInfoMixin.js';
    import NavLinks from './NavLinks.vue';

    export default {
        name: 'NavMenu',

        mixins: [
            AppInfoMixin,
        ],

        props: {
            group: {
                type: String,
                default: 'main'
            }
        },

        data() {
            return {};
        },

        computed: {
            ...mapGetters(['user_type']),

            routes() {
                return this.$router.options.routes.filter((route) => {
                    if ( !route.meta ) {
                        return false;
                    }

                    if ( Array.isArray(route.meta.perms) && !this.$userCan.apply(this, route.meta.perms) ) {
                        return false;
                    }

                    if ( Array.isArray(route.meta.user_types) && route.meta.user_types.indexOf(this.user_type) === -1 ) {
                        return false;
                    }

                    if ( route.meta.app && !route.meta.app.includes(this.app_type) ) {
                        return false;
                    }

                    return route.meta.group && route.meta.group === this.group;
                });
            }
        },

        methods: {
            hasChildren(route) {
                return (typeof route.children !== 'undefined');
            },

            defaultRoute(route) {
                return this.hasChildren(route) && route.children[0].path === ''
                    ? route.children[0].name
                    : false;
            }
        },

        components: {
            NavLinks
        }
    }
</script>
